import env from "../../utils/env";

let BotSessionsService = function (HttpService) {
  "ngInject";

  const getDataSource = (successCb) => {
    const dataSource = new kendo.data.DataSource({
      transport: {
        read: {
          url: env.getApiUrl("bigfoot/bot-sessions/search"),
          contentType: "application/json",
          type: "POST",
          beforeSend: _onBeforeSend,

        },
        parameterMap: _parameterMap
      },
      change: successCb,
      schema: {
        data: "data",
        total: "total"
      },
      serverFiltering: true,
      serverPaging: true,
      serverSorting: true,
      pageSize: 50
    })

    return dataSource;
  }

  const getSessionDetails = (sessionId, successCb, failureCb) => {
    HttpService.get(`bigfoot/bot-sessions/${sessionId}`, successCb, failureCb);
  }

  const getMessagesDataSource = (sessionId, successCb) => {
    const dataSource = new kendo.data.DataSource({
      transport: {
        read: {
          url: env.getApiUrl(`bigfoot/bot-sessions/${sessionId}/messages`),
          contentType: "application/json",
          type: "GET",
          beforeSend: _onBeforeSend,

        },
      },
      change: successCb,
      serverFiltering: false,
      serverPaging: false,
      serverSorting: false,
      pageSize: 50
    })

    return dataSource;
  }

  return {
    getDataSource,
    getSessionDetails,
    getMessagesDataSource,
  };
}

function _onBeforeSend(req) {
  var token = `Bearer ${window.localStorage.getItem("bigfootAccessToken")}`;

  req.setRequestHeader("Authorization", token);
}

function _parameterMap(data, type) {
  let filters = [];

  if(data.filter) filters = data.filter.filters;

  let query = Object.assign({}, { filters: filters }, data)
  delete query.filter;

  console.log("Query::", query)

  return JSON.stringify(query);
}

export default BotSessionsService;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/services/bot-sessions.service.js
 **/